import { toast } from "$global-providers/toast-provider";
import { gql } from "@apollo/client";
import { defineMessage, useIntl } from "react-intl";
import { useFinalizeInvoiceMutation } from "./__generated__/useFinaliseInvoice.gql";

const ERROR_MESSAGE = defineMessage({
  id: "invoicing.finaliseInvoice.error.msg",
  defaultMessage: "Failed to finalise this invoice",
});

gql`
  mutation finalizeInvoice($input: FinalizeInvoiceInput!) {
    finalizeInvoice(input: $input) {
      _id
      patientType
      created
      updated
      invoiceStatus
      balance {
        total
        paid
        due
        currency
      }
      payers {
        balance {
          total
          paid
          due
          currency
          waived
          exempt
        }
      }
    }
  }
`;

export default function useFinaliseInvoice(invoiceId: string) {
  const { formatMessage } = useIntl();
  const [finaliseInvoice] = useFinalizeInvoiceMutation({
    variables: {
      input: {
        _id: invoiceId,
      },
    },
    onError() {
      toast.error(formatMessage(ERROR_MESSAGE), {});
    },
  });

  return { finaliseInvoice };
}
